/**
 * Gets a handle to the photo directory in the Origin Private File System.
 * Creates the directory if it does not exist.
 * @returns {Promise<FileSystemDirectoryHandle>}
 */
async function getOrCreatePhotoDirectory() {
  const root = await navigator.storage.getDirectory();
  const photoDirectoryHandle = await root.getDirectoryHandle('photo_uploads', { create: true });
  return photoDirectoryHandle;
}

/**
 * Stores photo data in the Origin Private File System.
 * @param {string} key - The key to associate with the stored photo data.
 * @param {Blob} photoData - The photo data to be stored.
 * @returns {Promise<void>}
 */
async function storePhotoData(key, photoData) {
  const photoDirectoryHandle = await getOrCreatePhotoDirectory();
  const fileHandle = await photoDirectoryHandle.getFileHandle(key, { create: true });
  const stream = await fileHandle.createWritable();
  await stream.write(photoData);
  await stream.close();
}

/**
 * Removes photo data from the Origin Private File System.
 * @param {string} key - The key associated with the photo data to be removed.
 * @returns {Promise<void>}
 */
async function removePhotoData(key) {
  const photoDirectoryHandle = await getOrCreatePhotoDirectory();
  await photoDirectoryHandle.removeEntry(key);
}

/**
 * Retrieves photo data from the Origin Private File System.
 * @param {string} key
 * @returns {Promise<Blob>} The retrieved photo data.
 */
async function getPhotoData(key) {
  const photoDirectoryHandle = await getOrCreatePhotoDirectory();
  const fileHandle = await photoDirectoryHandle.getFileHandle(key);
  const file = await fileHandle.getFile();
  return file;
}

export { storePhotoData, removePhotoData, getPhotoData };
